import type { DrivingLogSettings } from '@/types/organizations';

export const DEFAULT_DRIVING_LOG_ORG_SETTINGS: DrivingLogSettings = {
  defaultServiceStart: '07:00',
  defaultServiceEnd: '17:00',
  cutOffEnabled: false,
  cutOffDayOfMonth: 5,
  reminderDaysBefore: 3,
  forwardingEmail: '',
  lockAfterSubmit: true,
  odometerAdjustmentLockEnabled: false,
};

export function mergeDrivingLogOrgSettings(raw?: DrivingLogSettings | null): DrivingLogSettings {
  return { ...DEFAULT_DRIVING_LOG_ORG_SETTINGS, ...(raw ?? {}) };
}
